import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import PasswordGate from './components/PasswordGate';
import AuthGuard from './components/AuthGuard';
import HomeRedirect from './components/HomeRedirect';
import Dashboard from './pages/Dashboard';
import PartnerDetail from './pages/PartnerDetail';
import PartnerPortal from './pages/PartnerPortal';
import AddPartner from './pages/AddPartner';
import RegistrationPage from './pages/RegistrationPage';
import AdminScreening from './pages/AdminScreening';
import AdminUsers from './pages/AdminUsers';
import LoginPage from './pages/LoginPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PasswordGate>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/" element={<AuthGuard><HomeRedirect /></AuthGuard>} />
            <Route path="/dashboard" element={<AuthGuard><Layout><Dashboard /></Layout></AuthGuard>} />
            <Route path="/portal/:partnerId" element={<AuthGuard><PartnerPortal /></AuthGuard>} />
            <Route path="/admin/screening" element={<AuthGuard><AdminScreening /></AuthGuard>} />
            <Route path="/admin/users" element={<AuthGuard><AdminUsers /></AuthGuard>} />
            <Route path="/partners/new" element={<AuthGuard><Layout><AddPartner /></Layout></AuthGuard>} />
            <Route path="/partners/:partnerId" element={<AuthGuard><Layout><PartnerDetail /></Layout></AuthGuard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </PasswordGate>
      </AuthProvider>
    </BrowserRouter>
  );
}
